import { isArray } from "lodash";
import { FC } from "react";

export const ShowError: FC<any> = ({ error }) => {
  console.log(error);

  return (
    <>
      <div className="alert alert-danger fv-plugins-message-container mt-4 ms-1 text-center">
        {isArray(error?.response?.data?.detail) ? (
          error?.response?.data?.detail?.map((error: any) => (
            <div
              data-field="appname"
              data-validator="notEmpty"
              className="fv-help-block"
            >
              {error.msg}
            </div>
          ))
        ) : error?.detail ? (
          <div
            data-field="appname"
            data-validator="notEmpty"
            className="fv-help-block"
          >
            {error?.detail}
          </div>
        ) : error?.response?.data?.detail ? (
          <div
            data-field="appname"
            data-validator="notEmpty"
            className="fv-help-block"
          >
            {error?.response?.data?.detail}
          </div>
        ) : error?.response?.data?.message ? (
          <div
            data-field="appname"
            data-validator="notEmpty"
            className="fv-help-block"
          >
            {error?.response?.data?.message}
          </div>
        ) : (
          <>
            {typeof error === "string" && (
              <div
                data-field="appname"
                data-validator="notEmpty"
                className="fv-help-block"
              >
                {error}
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};
